import { z } from 'zod';
import { CONTRIBUTORS_ROLES } from '@/types/dtos/contributors/response/contributor.dto';

export const generalSchema = z.object({
  fullName: z.string().min(2),
  title: z.string().optional(),
  organization: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
  phoneNumber: z.string().min(10).optional().or(z.literal('')),
  biography: z.string().optional(),
  assetName: z.string().optional(),
});

const rolesSchema = z.object({ role: z.enum(CONTRIBUTORS_ROLES), entity: z.string(), entityType: z.string() });
export type RolesSchema = z.infer<typeof rolesSchema>;
export const assignmentsSchema = z.object({ roles: z.array(rolesSchema).optional() });
export const addUpdateContributorSchema = z.object({
  general: generalSchema,
  assignments: assignmentsSchema,
});
export type StepsState = z.infer<typeof addUpdateContributorSchema>;
